import Vue from 'vue';
import VideoCard from '@/components/VideoCard.vue';
import { ViewerRoutes } from '../router';
import { mapGetters } from 'vuex';
import ChannelVideoTag from './ChannelVideoTag.vue';
import VideoCardSkeleton from '@/components/VideoCardSkeleton.vue';
import ChannelVideosGridLayout from './ChannelVideosGridLayout.vue';
import Linkify from './Linkify.vue';
const NUMBER_OF_SKELETONS = 15;
export default Vue.extend({
    name: 'ChannelVideos',
    props: {
        videos: {
            type: Array,
        },
        fullWidth: Boolean,
    },
    data() {
        return {
            renderVideos: !this.$store.state.channel?.channel.options.shuffleVideos ?? false,
        };
    },
    computed: {
        ...mapGetters(['channelTags']),
        videoURL() {
            return (video) => ({
                name: ViewerRoutes.ChannelVideo,
                params: {
                    vid: video.id,
                },
            });
        },
        withSidepanel() {
            const { showSearch, showTagNavigation } = this.$store.state.channel?.channel.options;
            return showSearch || showTagNavigation;
        },
        channelVideoTags() {
            return (video) => this.channelTags.filter((tag) => video.tags.includes(tag.id));
        },
        showTagNavigation() {
            const { showTagNavigation } = this.$store.state.channel?.channel.options;
            return showTagNavigation;
        },
        showTitle() {
            const { showTitle } = this.$store.state.channel?.channel.options;
            return showTitle;
        },
        showDuration() {
            const { showDuration } = this.$store.state.channel?.channel.options;
            return showDuration;
        },
        showDescription() {
            const { showDescription } = this.$store.state.channel?.channel.options;
            return showDescription;
        },
        showTags() {
            const { showTags } = this.$store.state.channel?.channel.options;
            return showTags;
        },
        tileSize() {
            const { tileSize } = this.$store.state.channel?.channel.options;
            return tileSize;
        },
        numberOfSkeletons() {
            return NUMBER_OF_SKELETONS;
        },
    },
    mounted() {
        this.renderVideos = true;
    },
    components: {
        VideoCard,
        ChannelVideoTag,
        VideoCardSkeleton,
        ChannelVideosGridLayout,
        Linkify,
    },
});
